export enum ExpressSetupSignUpErrorText {
  CONTACT_ALREADY_EXISTS = 'A contact with the specified username already exists.',
  TERMS_AND_CONDITIONS_NOT_CONFIRMED = 'Please confirm that you’ve read and acknowledge our Terms&Conditions and Privacy Policy.',
  ORGANIZATION_ALREADY_EXIST = 'Unique ID already exists in the system',
}

export enum ExpressSetupSignUpServerErrorText {
  CONTACT_ALREADY_EXISTS = 'username already exists',
  ORGANIZATION_ALREADY_EXIST = 'Organization with external identifier',
}

export enum EmployerIdType {
  AUTOMATICALLY = 'AUTOMATICALLY',
  CUSTOM = 'CUSTOM'
}

export const EMPLOYER_ID_OPTIONS = [
  {
    value: EmployerIdType.AUTOMATICALLY,
    label: 'Generate Employer ID automatically',
  },
  {
    value: EmployerIdType.CUSTOM,
    label: 'Custom Employer ID',
  }
];
